// src/locales/si/returnBatch.js
export const returnBatch = {
  // Page Titles
  createReturnBatch: " ආපසු භාර දීම",
  allReturnBatches: "Return කෙටුම්",
  returnBatchDetails: "Return කෙටුම් විස්තර",
  viewAndManageAllReturnBatches: "හැම Return කෙටුමක්ම බැලීම සහ කළමනාකරණය",

  // Main Interface
  scanToReturn: "Return කිරීමට Scan කරන්න",
  scanAirwaybillOrOrder: "Airwaybill හෝ විධාන අංකය Scan කරන්න",
  scanPlaceholder: "Barcode scan කරන්න හෝ order/airwaybill අංකය ඇතුළත් කරන්න...",

  // Courier & Warehouse Selection
  selectCourier: "Courier ගිණුම තෝරන්න",
  selectCourierFirst: "ආරම්භ කිරීමට Courier ගිණුම තෝරන්න",
  selectWarehouse: "ගබඩාව තෝරන්න",
  selectWarehouseFirst: "ආරම්භ කිරීමට ගබඩාව තෝරන්න",
  courierRequired: "Courier ගිණුම අවශ්‍යයි",
  warehouseRequired: "ගබඩාව අවශ්‍යයි",

  // Batch Management
  activeBatch: "සක්‍රීය කෙටුම",
  noBatchFound: "සක්‍රීය කෙටුම හමු නොවිණි",
  newBatchWillBeCreated: "පළමු scan සමඟ නව කෙටුමක් සෑදේ",
  multipleBatchesFound: "Multiple කෙටුම් හමු විය",
  selectBatch: "කෙටුම තෝරන්න",
  createNewBatch: "නව කෙටුමක් සෑදීම",
  batchNumber: "කෙටුම් අංකය",
  switchBatch: "කෙටුම පරිවර්තනය",
  closeBatch: "කෙටුම වසා දමන්න",
  confirmCloseBatch: "ඔබට {batchNumber} කෙටුම වසා දැමීමට අවශ්‍යද? මෙය පසු පියවරකට නැවත නැවත ගැනීමට නොහැක.",
  confirmBulkClose: "ඔබට කෙටුම් {count} ක් වසා දැමීමට අවශ්‍යද?",
  batchClosedSuccessfully: "කෙටුම සාර්ථකව වසන ලදී",
  bulkClosedSuccessfully: "කෙටුම් {count} ක් සාර්ථකව වසන ලදී",
  failedToCloseBatch: "කෙටුම වසීමට අසමත් විය",
  failedToCloseSomeBatches: "කෙටුම් කිහිපයක් වසීමට නොහැකි විය",
  noActiveBatchesSelected: "සක්‍රීය කෙටුමක් තෝරා නැත",

  // Current Batch Info
  currentBatch: "වත්මන් කෙටුම",
  totalOrders: "Orders එකතුව",
  totalValue: "එකතුව",
  createdBy: "සාදන ලද්දේ",
  createdAt: "සාදා ඇත",

  // Scan Results
  orderReturned: "Order එක සාර්ථකව Return කර ඇත",
  returnFailed: "Return අසමත් විය",
  orderNumber: "Order අංකය",
  airwaybillNumber: "Airwaybill",
  customerName: "පාරිභෝගික",
  grandTotal: "Total",
  codAmount: "COD Amount",
  paymentType: "ගෙවීමේ වර්ගය",
  shop: "Shop",
  newStatus: "New Status",

  // Stock Movements
  stockRestored: "Stock නැවත ලබාදී ඇත",
  stockMovements: "Stock චලන",
  productName: "භාණ්ඩය",
  quantityRestored: "නැවත ලබාදුන් ප්‍රමාණය",
  viewStockDetails: "Stock විස්තර බැලීම",

  // Recent Returns
  recentReturns: "දැනටමත් return කළ orders",
  noReturnsYet: "මෙම session එකේ returns නොමැත",
  returnedOrders: "Returned orders මෙහි පෙන්වනු ඇත",

  // Error Messages
  orderNotFound: "Order හමු නොවිණි",
  orderAlreadyReturned: "Order එක Return වී ඇත",
  orderNotDispatched: "Order එක Dispatch කර නැත",
  orderFromDifferentCourier: "Order එක වෙනත් Courier එකකට අයත්",
  orderFromDifferentWarehouse: "Order එක වෙනත් ගබඩාවකට අයත්",
  orderAlreadyClosed: "Order එක වසා ඇති",
  scanRequired: "කරුණාකර order scan කරන්න",
  failedToReturn: "Order Return කිරීමට අසමත් විය",
  failedToLoadBatches: "Return කෙටුම් Load කිරීමට අසමත් විය",
  failedToLoadReferenceData: "Reference data load කිරීමට අසමත් විය",
  failedToCreateBatch: "කෙටුම සෑදීමට අසමත් විය",
  failedToLoadBatchDetails: "කෙටුම් විස්තර load කිරීමට අසමත් විය",

  // Notes
  addNotes: "සටහන් එක් කරන්න",
  notesPlaceholder: "මෙම කෙටුම පිළිබඳ සටහන්...",
  notes: "සටහන්",
  batchNotes: "කෙටුම් සටහන්",
  returnNotes: "Return සටහන්",
  notesOptional: "සටහන් (විකල්පයි)",

  // Actions
  clear: "Clear",
  viewDetails: "විස්තර බලන්න",
  viewAllBatches: "සියලු කෙටුම් බලන්න",
  processReturns: "Returns සකසන්න",
  closeSelected: "තෝරාගත් {count} වසන්න",
  back: "පසු",
  backToBatches: "කෙටුම් වෙත නැවත යන්න",
  addMoreOrders: "තවත් orders එකතු කරන්න",
  printReport: "Report print කරන්න",
  exportOrders: "Orders export කරන්න",
  createBatchNow: "කෙටුම දැන් සාදන්න",
  createBatch: "කෙටුම සාදන්න",
  cancel: "අවලංගු",
  processing: "සැකසෙමින්...",
  closing: "වසමින්...",

  // Statistics
  todayReturns: "අද Returns",
  sessionReturns: "මෙම Session",
  batchReturns: "Batch Returns",
  batchValue: "Batch value",
  thisSession: "මෙම session",
  avgOrderValue: "Average Order Value",
  codOrders: "COD Orders",
  prepaidOrders: "Prepaid Orders",

  // Keyboard Shortcuts
  keyboardShortcuts: "Keyboard shortcuts",
  focusInput: "Input field focus",
  submitScan: "Scan submit",
  clearForm: "Form clear",
  newBatch: "නව කෙටුම",

  // Empty States
  noActiveBatch: "සක්‍රීය කෙටුමක් නොමැත",
  selectCourierToBegin: "Returns ක්‍රියාකරවීමට Courier ගිණුමක් තෝරන්න",
  noReturnBatchesYet: "Return කෙටුම් නොමැත. Returns ක්‍රියාකරවීම ආරම්භ කරන්න.",
  noBatchesFound: "Search criteria එකට பொருந்தும் කෙටුම් නොමැත",
  noOrdersFound: "Orders නොමැත",
  noOrdersMatchFilters: "Filters වලට பொருந்தும் orders නොමැත",

  // Validation
  identifierRequired: "Order identifier අවශ්‍යයි",
  pleaseScanOrder: "කරුණාකර order scan කරන්න",
  pleaseSelectCourier: "Courier ගිණුම තෝරන්න",
  pleaseSelectWarehouse: "ගබඩාව තෝරන්න",

  // Success Messages
  batchCreatedSuccessfully: "Return කෙටුම සාර්ථකව සෑදන ලදි",
  orderAddedSuccessfully: "Order එක කෙටුමට එක් කළා",
  batchCreatedAutomatically: "කෙටුම {batchNumber} ස්වයංක්‍රීයව සෑදන ලදි",
  orderReturnedSuccessfully: "Order {orderNumber} සාර්ථකව Return කලා",
  ordersExportedSuccessfully: "Orders export කරන ලදී",

  // Filter Labels
  warehouse: "ගබඩාව",
  courierCompany: "Courier ආයතනය",
  courierAccount: "Courier ගිණුම",
  account: "Account",
  courier: "Courier",
  orders: "Orders",
  dateRange: "දින පරාසය",
  searchByBatchNumber: "Batch අංකයෙන් search කරන්න...",
  searchOrders: "Orders search කරන්න...",
  allWarehouses: "සියලු ගබඩා",
  allCourierCompanies: "සියලු Courier සමාගම්",
  allCourierAccounts: "සියලු Courier ගිණුම්",
  allStatuses: "සියලු Status",
  allStatus: "සියලු Status",

  // Status Labels
  statusActive: "සක්‍රීයයි",
  statusClosed: "වසා ඇත",
  status: "Status",
  success: "Success",
  failed: "Failed",
  pending: "Pending",
  restored: "Restored",
  notRestored: "Restore නොවීය",

  // Headers & Sections
  setup: "Setup",
  multipleActiveBatchesFound: "වෙනස් සක්‍රීය කෙටුම් හමු විය",
  orderReturnedSuccessfully: "Order එක සාර්ථකයි!",
  scanToRestoreInventory: "Inventory නැවත ලබාගැනීමට scan කරන්න",
  loadingBatchDetails: "කෙටුම් විස්තර loading...",
  batchNotFound: "කෙටුම හමු නොවිණි",

  // Details Page
  created: "Created",
  closed: "Closed",
  by: "විසින්",
  unknown: "Unknown",
  copyAirwaybill: "Airwaybill copy කරන්න",

  // Breakdowns
  paymentTypeBreakdown: "Payment Type Breakdown",
  shopBreakdown: "Shop Breakdown",
  activityTimeline: "Activity Timeline",
  ordersInBatch: "Batch Orders",

  // Order Details
  orderDetails: "Order විස්තර",
  deliveryAddress: "විසිතුරු ලිපිනය",
  contactNumbers: "දුරකථන අංක",
  orderStatus: "Order Status",
  currentStatus: "Current Status",
  errorMessage: "Error message",
  primary: "Primary",

  // Timeline
  batchCreated: "කෙටුම සාදන ලදි",
  orderAdded: "Order {orderNumber} එකතු කරන ලදී",
  addedBy: "එක් කළා",
  closedBy: "වසා දැමුවේ",

  // Table Headers
  airwaybill: "Airwaybill",
  customer: "පාරිභෝගික",
  phone: "දුරකථන",
  city: "නගරය",
  payment: "ගෙවීම",
  orderValue: "Order අගය",
  stock: "Stock",
  returnedBy: "ආපසු ලබාදුන්නේ",
  returnedAt: "Return කළ දිනය",

  // Misc
  na: "N/A",
  qty: "Qty",

  // Order Items & Product List
  items: "භාණ්ඩ",
  orderItems: "ඇණවුම් භාණ්ඩ",
  productListTitle: "භාණ්ඩ ලැයිස්තුව ({{count}})",
  viewOrdersTab: "ඇණවුම්",
  viewProductsTab: "භාණ්ඩ",
  searchProductsPlaceholder: "භාණ්ඩ සොයන්න...",
  productColumn: "භාණ්ඩය",
  skuColumn: "SKU",
  totalQuantityColumn: "මුළු ප්‍රමාණය",
  orderCountColumn: "ඇණවුම්",
  loadingProductList: "භාණ්ඩ ලැයිස්තුව පූරණය වෙමින්...",
  noProductsFound: "භාණ්ඩ හමු නොවිණි",
  noProductsFoundDescription: "ඔබගේ වත්මන් පෙරහන්වලට කිසිදු භාණ්ඩයක් නොගැලපේ",
  loadProductListError: "භාණ්ඩ ලැයිස්තුව පූරණය කිරීමට අසමත් විය",
  printProductList: "මුද්‍රණය කරන්න",
  exportExcel: "Excel",
  exportPdf: "PDF"
};
